export default {
      id: "pen-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#pen",
      toString: function () {
        return this.url;
      }
    }